import { render, staticRenderFns } from "./IndicesCpo.vue?vue&type=template&id=6e2754f7"
import script from "./IndicesCpo.vue?vue&type=script&lang=js"
export * from "./IndicesCpo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports